import { BaseSelect } from '@app/components';
import { customerApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { ICustomer } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<ICustomer>();

const columns = [
  columnHelper.display({
    id: 'name',
    header: () => (
      <BaseSelect.ListHeaderItem width="50%">
        Nom complet
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="50%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.row.original.lastname} {info.row.original.firstname}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
  columnHelper.accessor('phone', {
    header: () => (
      <BaseSelect.ListHeaderItem width="50%">
        Téléphone
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="50%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
];

export const CustomerSelect = ({ label = 'Clients', ...props }: ResourceSelectParentProps<ICustomer>) => {
  return (
    <ResourceSelect
      label={label}
      columns={columns}
      nameKey='lastname'
      useQuery={customerApi.useReadManyCustomersQuery}
      selectedColumns={columns}
      {...props} />
  );
};
